
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article-expired",
      function () {
        return require("private-next-pages/article-expired.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article-expired"])
      });
    }
  